import { Row, Col, Drawer,Typography ,Avatar,Divider} from "antd";
import React, {  useState } from "react";
import './Header.css';
import { Menu } from "antd";
import {MenuFoldOutlined} from '@ant-design/icons';

const { Title ,Text} = Typography;

const Header = () => {
    const [open, setOpen] = useState(false);

    const showDrawer = () => {
        setOpen(true);
    };
    const onClose = () => {
        setOpen(false);
    };
    return (
        <header className="header" >
            <div className="container">
                <Row type="flex" justify="space-between" align="middle">
                    <Col span={6} className=""><a href="/">
                        <img src="../../images/hero-logo.png" alt="" />
                    </a></Col>
                    <Col span={18} className="menu"  >
                        <div className=" desktop-menu">
                        
                            <Menu style={{ backgroundColor: 'transparent' }}  mode="horizontal" 
                            items={[
                                { label: "Home", key: "home" },
                                { label: "About Us", key: "about" },
                                { label: "TestNet", key: "testnet" },
                                { label: "Test-Drive", key: "testdrive" },
                                { label: "Sync2", key: "Sync2" },
                                { label: "Sign in", key: "signin" ,className:"signIn_button" }
                            ]}></Menu>
                           
                        </div>
                        <div className="humberger_button"> 
                        <MenuFoldOutlined className="barsMenu " onClick={showDrawer} style={{ fontSize: '50px', color: '#fff' }} />
                         </div>
                        <Drawer placement="right" onClose={onClose} open={open} justify="end" className="drawer">
                            <div className='mobile-menu'>
                            <Avatar size={144}>Avatar</Avatar>
                            <div className='mobile-head-box'>
                            <Title level={2}>Denis Lavodic</Title>
                            <Text>Designer</Text>
                            </div>
                                <Menu style={{ backgroundColor: 'transparent' }} mode="inline" defaultOpenKeys={["home-m"]} items={[
                                    { icon: <img src="../../images/twitter.png" alt=""/>, label: "Home", key: "home-m",
                                    children:[
                                        { label: "About Us", key: "about_child" },
                                        { label: "Database", key: "db" },
                                        { label: "Feature", key: "feature" },
                                        { label: "Codes of API", key: "codes" },
                                        { label: "History", key: "history" },
                                    ] },
                                    { label: "Messages", key: "msg" },
                                    { label: "Database", key: "dbs" },
                                    { label: "Codes", key: "code" },
                                    
                                    { label: "Settings", key: "settings" },
                                    { label: "Log Out", key: "logout" },
                                ]}></Menu>
                                <Divider/>
                                  <Menu style={{ backgroundColor: 'transparent' }} mode="inline" items={[
                                    { label: "Settings", key: "settings" },
                                    { label: "Log Out", key: "logout" },
                                ]}></Menu>
                            </div>
                        </Drawer>
                    </Col>
                </Row>
            </div>
        </header>
    );
}
export default Header;


